import React from "react";
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import {
          getMobileLocation,
          listMobileLocations,
       } from 'graphql/queries'

import {
  createPhoto,
  createAddress,
  updateAddress,
  createMobileLocation,
  updateMobileLocation,
  deletePhoto,
  createLocationScheduleException
} from 'graphql/mutations';
       
import {API} from '@aws-amplify/api'
import {Storage} from '@aws-amplify/storage'
import awsMobile from 'aws-exports';
import AWS from 'aws-sdk';
import {Actions as NOTIFICATIONACTIONS} from 'store/notifications/action';

// types of action
const Types = {
  MOBILELOCATION_GET_ITEM: "MOBILELOCATION_GET_ITEM",
  MOBILELOCATION_UPDATE_ITEM: "MOBILELOCATION_UPDATE_ITEM",
  MOBILELOCATION_CREATE_ITEM: "MOBILELOCATION_CREATE_ITEM",
  MOBILELOCATION_CLEAR_ITEM: "MOBILELOCATION_CLEAR_ITEM",
  MOBILELOCATION_LOADING: "MOBILELOCATION_LOADING",
  MOBILELOCATION_GET_LIST: "MOBILELOCATION_GET_LIST",
  MOBILELOCATION_UPLOAD_IMAGE: "MOBILELOCATION_UPLOAD_IMAGE",
  MOBILELOCATION_DELETE_IMAGE: "MOBILELOCATION_DELETE_IMAGE",
  MOBILELOCATION_SELECTED: "MOBILELOCATION_SELECTED",
  MOBILELOCATION_CREATE_LOCATION_SCHEDULE_EXCEPTION: "MOBILELOCATION_CREATE_LOCATION_SCHEDULE_EXCEPTION",
  MOBILELOCATION_UPDATE_LOCATION_SCHEDULE_EXCEPTION: "MOBILELOCATION_UPDATE_LOCATION_SCHEDULE_EXCEPTION",
  MOBILELOCATION_DELETE_LOCATION_SCHEDULE_EXCEPTION: "MOBILELOCATION_DELETE_LOCATION_SCHEDULE_EXCEPTION",
};

const dispatchLoading =  loading => ({
  type: Types.MOBILELOCATION_LOADING,
  loading
});

const clearItem = response => ({
  type: Types.MOBILELOCATION_CLEAR_ITEM
});

const dispatchGetItem = response => ({
  type: Types.MOBILELOCATION_GET_ITEM,
  payload: response
});

const getItem = (id) => {
  console.log('getItem1',getItem)
  return (dispatch, getState) => {
    dispatch(dispatchLoading(true))

    const variables = {id}
    const request = API.graphql({query: getMobileLocation, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})
    console.log('getItem2',getItem)
    request.then((response) => {
        dispatch(dispatchGetItem(response))
        dispatch(dispatchLoading(false))
    });
    
  }
}

const dispatchUpdateItem = response => ({
  type: Types.MOBILELOCATION_UPDATE_ITEM,
  payload: response
});

const updateLocationAddress = async (address) => {
  // return (dispatch, getState) => {

    console.log('addressID',address.id, address)

    delete address._lastChangedAt;

    const variables = {input: address}
    const request = API.graphql({query: updateAddress, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    // ensure that if new address it has the business id
    // if (variables.input.address && !variables.input.address.id){
    //   variables.input.address.businessID = businessID;
    // }

    const response = await request/*.then((response) => {
        // dispatch(dispatchUpdateAddress(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment>Location Address has been updated</React.Fragment>,
          // message: response.data.updateLocation.active ? `Customers can book this location` : `This location is disabled. It cannot be booked`,
          icon: `success`,
        },
          3000
        ))
    });*/

    return response.data.updateAddress.id
    
  // }
}


const createLocationAddress = async (address) => {
  // return (dispatch, getState) => {

    console.log('addressID',address.id, address)

    delete address._lastChangedAt;

    const variables = {input: address}
    const request = API.graphql({query: createAddress, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    // ensure that if new address it has the business id
    // if (variables.input.address && !variables.input.address.id){
    //   variables.input.address.businessID = businessID;
    // }

    const response = await request/*.then((response) => {
        // dispatch(dispatchUpdateAddress(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment>Location Address has been updated</React.Fragment>,
          // message: response.data.updateLocation.active ? `Customers can book this location` : `This location is disabled. It cannot be booked`,
          icon: `success`,
        },
          3000
        ))
    });*/

    return response.data?.createAddress?.id
    
  // }
}

const updateItem = (item) => {
  return async (dispatch, getState) => {

    const state = getState()
    const businessID = state.businessID

    const address = item.address

    // console.log('item.addressID',item.addressID,item.address.id)

    if (address && item.addressID && item.address && item.address.id == item.addressID){
      updateLocationAddress({...address, businessID})
    } else {
      const addressID = uuidv4()
      address.id = addressID;
      item.addressID = addressID;

      delete address._version

      createLocationAddress({...address, businessID})
    }
 

    // item.addressID = addressID;

    delete item.address;

    const variables = {input: item}
    const request = API.graphql({query: updateMobileLocation, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    // ensure that if new address it has the s idbusines
    
    // if (variables.input.address && !variables.input.address.id){
    //   variables.input.address.businessID = businessID;
    // }

    request.then((response) => {
        dispatch(dispatchUpdateItem(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment><strong>{response.data.updateMobileLocation.name}</strong> has been updated</React.Fragment>,
          // message: response.data.updateLocation.active ? `Customers can book this location` : `This location is disabled. It cannot be booked`,
          icon: `success`,
        },
          3000
        ))
    });
    
  }
}

const dispatchCreateItem = response => ({
  type: Types.MOBILELOCATION_CREATE_ITEM,
  payload: response
});

const createItem = (item) => {
  return (dispatch, getState) => {

    console.log('businessID',getState('businessID'))
    const address = item.address

    const addressID = uuidv4()
    address.id = addressID;
    item.addressID = addressID;

    createLocationAddress(address)

    // item.addressID = addressID;

    delete item.address;


    item.addressID = addressID;

    
    const state = getState()

    const businessID = state.businessID
    const variables = {input: {...item, businessID}}

    // the address also needs the business id
    // if (variables.input.address){
    //   variables.input.address.businessID = businessID;
    // }

    const request = API.graphql({query: createMobileLocation, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
        dispatch(dispatchCreateItem(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment><strong>{response.data.createMobileLocation.name}</strong> has been created</React.Fragment>,
          // message: response.data.updateLocation.status == "Active" ? `This location is raring and ready to go.` : `This location is disabled and cannot be booked.`,
          icon: `success`,
        },3000))
    });
    
  }
}

const setSelectedMobileLocation = selected => ({
  type: Types.MOBILELOCATION_SELECTED,
  selected
});

const updateList = response => ({
  type: Types.MOBILELOCATION_GET_LIST,
  payload: response
});

const getList = (limit, nextToken) => {
  return (dispatch, getState) => {

    const variables = {limit, nextToken}
    const request = API.graphql({query: listMobileLocations, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
        dispatch(updateList(response))
    });
    
  }
}


const handleDeletePhoto = (id) => {
  return (dispatch, getState) => {

    const state = getState()

    // get item for version
    const item = _.find(state.mobileLocation.item.photos.items,{id})

    const variables = {input: { id, _version: item._version } }
    const request = API.graphql({query: deletePhoto, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
        // dispatch(dispatchCreateItem(response))
        return dispatch({
          type: Types.MOBILELOCATION_DELETE_IMAGE,
          payload: response
        })

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment><strong>Image</strong> has been deleted</React.Fragment>,
          // message: response.data.updateLocation.status == "Active" ? `This location is raring and ready to go.` : `This location is disabled and cannot be booked.`,
          icon: `success`,
        },3000))
    });

  }
}

const handleUpload = (file, preFileName) => {
  return (dispatch, getState) => {

    const state = getState()

    const businessID = state.businessID

    console.log(file,'show me the file!')

    const {
      aws_user_files_s3_bucket_region: region,
      aws_user_files_s3_bucket: bucket
    } = awsMobile


    console.log(bucket,'this is the bucket!')

    const { name: fileName, type: mimeType } = file;

    const filePath = `mobileLocation/${state.mobileLocation.item.id}/${fileName}`  

    const key = preFileName ? preFileName : filePath

    const fileForUpload = {
      bucket,
      key,
      region,
      type: mimeType
    };

    dispatch(NOTIFICATIONACTIONS.addNotification({
      title: <React.Fragment><strong>Image</strong> is currently uploading. Please wait...</React.Fragment>,
      // message: response.data.updateLocation.status == "Active" ? `This location is raring and ready to go.` : `This location is disabled and cannot be booked.`,
      icon: `success`,
    },3000))


    const request = Storage.put(key, file, {
      level: 'public',
      contentType: mimeType,
      progressCallback: (e) => {
          console.log(e,'this is a callback! from storage')
      }
    });


    request.then(() => {

      // image saved add into GQL
      
      const variables = {
        input : {
          // id: uuidv4()
          businessID,
          // description: String
          photo: {
            bucket,
            key,
          },
          photoMobileLocationId: state.mobileLocation.item.id
        }
      }

        const request = API.graphql({query: createPhoto, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

        request.then((response) => {
            // dispatch(dispatchCreateItem(response))
            return dispatch({
              type: Types.MOBILELOCATION_UPLOAD_IMAGE,
              payload: response
            })

            //TODO Plan notification logic/errors
            dispatch(NOTIFICATIONACTIONS.addNotification({
              title: <React.Fragment><strong>Image</strong> has been uploaded</React.Fragment>,
              // message: response.data.updateLocation.status == "Active" ? `This location is raring and ready to go.` : `This location is disabled and cannot be booked.`,
              icon: `success`,
            },3000))
        });

    });
  }
}



const newLocationScheduleException = response => ({
  type: Types.MOBILELOCATION_CREATE_LOCATION_SCHEDULE_EXCEPTION,
  payload: response
});


const createLocationScheduleExceptionAction = (item) => {

  return async (dispatch, getState) => {


    const state = getState()
    const businessID = state.businessID

    item.businessID = businessID
    item.locationID = state.location.item.id
    if (!item.mobileLocationID){
      item.mobileLocationID = state.mobileLocation.selected
    }

    // date: AWSDate!
    // disabled: Boolean
    

    // const {} = item

    const variables = {input: item}
    const request = API.graphql({query: createLocationScheduleException, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    const response = await request/*.then((response) => {
        // dispatch(dispatchUpdateAddress(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment>Location Address has been updated</React.Fragment>,
          // message: response.data.updateLocation.active ? `Customers can book this location` : `This location is disabled. It cannot be booked`,
          icon: `success`,
        },
          3000
        ))
    });*/

    dispatch(newLocationScheduleException)

    return response.data.createLocationScheduleException.id
    
  }
}


const Actions = {
  getItem,
  createItem,
  updateItem,
  getList,
  clearItem,
  handleUpload,
  handleDeletePhoto,
  setSelectedMobileLocation,
  createLocationScheduleException: createLocationScheduleExceptionAction
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions